import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { roleNames } from "../constant";

const PublicRoute = ({ children }) => {
  const token = useSelector((state) => state.auth.jwtToken);
  const role = useSelector((state) => state.auth.role);

  if (token) {
    switch (role) {
      case roleNames.superAdmin:
        return <Navigate to="/admin-dashboard" replace />;
      case roleNames.qa:
        return <Navigate to="/qa-dashboard" replace />;
      default:
        return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default PublicRoute;
